import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { motion, AnimatePresence } from 'framer-motion';
import { Folder } from '../../../../types/folder';

interface FolderDroppableAreaProps {
  children: React.ReactNode;
  folder: Folder | null; // null 表示"未分组"
  isActive?: boolean;
  className?: string;
  isFullArea?: boolean; // 是否为整个文件夹区域（包括内容）
}

/**
 * 可放置的文件夹区域组件
 * 使文件夹区域可以接收项目拖放
 */
export const FolderDroppableArea: React.FC<FolderDroppableAreaProps> = ({
  children,
  folder,
  isActive = false,
  className = '',
  isFullArea = false
}) => {
  // 获取文件夹ID，未分组使用特殊ID
  const folderId = folder ? folder.id : 'ungrouped';

  // 使用dnd-kit的useDroppable钩子
  const { setNodeRef, isOver } = useDroppable({
    id: `folder-${folderId}`,
    data: {
      type: 'folder',
      folderId: folderId,
      folder: folder
    }
  });

  // 计算当前是否处于激活状态（拖拽悬停或外部传入的激活状态）
  const isActiveState = isOver || isActive;

  return (
    <div ref={setNodeRef} className={`relative ${className}`}>
      {/* 高亮效果 */}
      <AnimatePresence>
        {isActiveState && (
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.2 }}
            className={`absolute inset-0 bg-ios-blue/10 dark:bg-ios-dark-blue/20 z-0 pointer-events-none ${
              isFullArea ? 'rounded-lg' : 'rounded-ios-md'
            }`}
          />
        )}
      </AnimatePresence>

      {/* 内容 */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};
